import React from "react";

import {
  ArrowRightOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import { Layout, DatePicker, Button, Pagination, Spin } from "antd";

import Base from "../Base";

//redux
import { connect } from "react-redux";
import { getUserInfo } from "../../utils/redux/reducers/User";

class OrderDownload extends Base {
  static Tabs = [
    { key: "generate", name: "orderDownload.tabs.generate" },
    { key: "history", name: "orderDownload.tabs.history" },
  ];

  /* lifcyle methods */

  constructor(props) {
    super(props);

    this.afterSomeSecond = 1;
    this.state = {
      ...this.state,

      currentTab: this.getRouterQueryItemByKey(OrderDownload.Tabs, "tab"),

      rangeTime: this.getDefaultTimeRange(),

      generatingBill: false,

      list: null,
      loadingList: false,
      deletingBill: false,
      currentPage: this.getRouterQueryPage(),
      currentPageSize: this.getRouterQueryPageSize(),
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.getUser()) {
      if (this.isCurrentTabHistory()) {
        this.showMessage(
          this.i18n.t("financeDownload.loadingData"),
          Base.Message.loading
        );
        this.loadList();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate(prevProps, prevState);

    if (prevState.currentTab.key !== this.state.currentTab.key) {
      if (this.isCurrentTabHistory()) {
        this.showMessage(
          this.i18n.t("financeDownload.loadingData"),
          Base.Message.loading
        );
        this.loadList();

        this.setRouterQuery({
          tab: this.state.currentTab.key,
          page: this.state.currentPage,
          pageSize: this.state.currentPageSize,
        });
      } else {
        this.setRouterQuery({
          tab: this.state.currentTab.key,
          timeRange: `${this.state.rangeTime[0].format(
            "YYYY-MM-DD"
          )}~${this.state.rangeTime[1].format("YYYY-MM-DD")}`,
        });
      }
    } else {
      if (this.isCurrentTabHistory()) {
        if (
          prevState.currentPage !== this.state.currentPage ||
          prevState.currentPageSize !== this.state.currentPageSize
        ) {
          this.showMessage(
            this.i18n.t("financeDownload.loadingData"),
            Base.Message.loading
          );
          this.loadList();

          this.setRouterQuery({
            page: this.state.currentPage,
            pageSize: this.state.currentPageSize,
          });
        }
      } else {
        if (
          prevState.rangeTime[0].diff(this.state.rangeTime[0]) !== 0 ||
          prevState.rangeTime[1].diff(this.state.rangeTime[1]) !== 0
        ) {
          this.setRouterQuery({
            timeRange: `${this.state.rangeTime[0].format(
              "YYYY-MM-DD"
            )}~${this.state.rangeTime[1].format("YYYY-MM-DD")}`,
          });
        }
      }
    }
  }

  /* render methods */

  render() {
    return (
      <Layout id="route-finance-download">
        {this._renderHeader()}
        {this._renderContentByTab()}
      </Layout>
    );
  }

  _renderHeader() {
    return (
      <div className="header-wrap">
        {OrderDownload.Tabs.map((tab, index) => {
          let items = [];
          let className =
            this.state.currentTab.key === tab.key ? "primary" : "default";
          items.push(
            <Button
              key={`tab-${index}`}
              type={className}
              onClick={() => this.onHeaderTabClick(tab)}
            >
              {this.i18n.t(tab.name)}
            </Button>
          );

          if (index !== OrderDownload.Tabs.length - 1) {
            items.push(<ArrowRightOutlined key={`arrow-${index}`} />);
          }

          return items;
        })}
      </div>
    );
  }

  _renderContentByTab() {
    if (this.isCurrentTabGenerate()) {
      return this._renderGenerateContent();
    } else if (this.isCurrentTabHistory()) {
      return this._renderHistoryContent();
    } else {
      return null;
    }
  }

  _renderGenerateContent() {
    return (
      <div className="generate-wrap">
        {this._renderGenerateFilter()}
        {this._renderGenerateButton()}
      </div>
    );
  }

  _renderGenerateFilter() {
    return (
      <div className="generate-filter">
        <div className="filter-row">
          <span className="label margin">
            {this.i18n.t("financeDownload.generateFilterTime")}
          </span>
          <DatePicker.RangePicker
            size="small"
            defaultValue={this.state.rangeTime}
            format="YYYY-MM-DD"
            allowClear={false}
            onChange={this.handleFiltersTimeChange}
            disabledDate={this.disabledDate}
          />
        </div>
      </div>
    );
  }

  _renderGenerateButton() {
    return (
      <div className="generate-button">
        <Button type="primary" onClick={this.onGenerateClick}>
          {this.i18n.t("orderDownload.generateActionGenerate")}
        </Button>
      </div>
    );
  }

  _renderHistoryContent() {
    return (
      <div className="history-wrap">
        {this._renderHistoryHeader()}
        {this._renderHistoryList()}
        {this._renderHistoryPagination()}
      </div>
    );
  }

  _renderHistoryHeader() {
    return (
      <div className="history-header">
        <span className="no">
          {this.i18n.t("financeDownload.historyHeaderNo")}
        </span>
        <span className="name">
          {this.i18n.t("financeDownload.historyHeaderName")}
        </span>
        <span className="date">{this.i18n.t("orderDownload.date")}</span>
        <span className="count">{this.i18n.t("orderDownload.orderCount")}</span>
        <span className="status">
          {this.i18n.t("financeDownload.historyHeaderStatus")}
        </span>
        <span className="actions">
          {this.i18n.t("financeDownload.historyHeaderActions")}
        </span>
      </div>
    );
  }

  _renderHistoryList() {
    let data = this.state.list;
    if (data) {
      let list = data ? data.data : null;
      if (list && list.length > 0) {
        return (
          <Spin spinning={this.state.loadingList || this.state.deletingBill}>
            <div className="history-list">
              {list.map((item, index) => {
                let statusClassName = "";
                let statusIconType = "";
                let statusText = "";
                let actions = [];

                if (item.status === 0) {
                  statusClassName = "status progress";
                  statusIconType = <ClockCircleOutlined />;
                  statusText = this.i18n.t(
                    "financeDownload.historyItemStatusGenerating"
                  );
                } else if (item.status === 1) {
                  statusClassName = "status";
                  statusIconType = <CheckCircleOutlined />;
                  statusText = this.i18n.t(
                    "financeDownload.historyItemStatusSuccess"
                  );
                  actions.push(
                    <a
                      key="action-download"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={item.download_url}
                    >
                      {this.i18n.t("financeDownload.historyItemActionDownload")}
                    </a>
                  );
                } else if (item.status === 2) {
                  statusClassName = "status error";
                  statusIconType = <CloseCircleOutlined />;
                  statusText = this.i18n.t(
                    "financeDownload.historyItemStatusFailed"
                  );
                  actions.push(<span key="status-error" />);
                }

                return (
                  <div
                    key={`list-item-${index}`}
                    className="history-header item"
                  >
                    <span className="no">{item.id}</span>
                    <span className="name">{item.file_name}</span>
                    <span className="date">{`${item.start_date}~${item.end_date}`}</span>
                    <span className="count">{item.orders_count}</span>
                    <span className={statusClassName}>
                      {statusIconType}
                      <span>{statusText}</span>
                    </span>
                    <span className="actions">{actions}</span>
                  </div>
                );
              })}
            </div>
          </Spin>
        );
      } else {
        return (
          <div className="history-list">
            <div className="list-message">
              {this.i18n.t("financeDownload.loadingEmpty")}
            </div>
          </div>
        );
      }
    } else {
      if (this.state.loadingList) {
        return (
          <div className="history-list">
            <div className="list-message">
              {this.i18n.t("financeDownload.loadingData")}
            </div>
          </div>
        );
      }

      return (
        <div className="history-list">
          <div className="list-message">
            {this.i18n.t("financeDownload.loadingEmpty")}
          </div>
        </div>
      );
    }
  }

  _renderHistoryPagination() {
    let data = this.state.list;
    if (data && data.data && data.data.length > 0) {
      return (
        <div className="history-pagination">
          <Pagination
            total={data.total}
            current={this.state.currentPage}
            showSizeChanger={true}
            pageSizeOptions={["10", "20", "30"]}
            pageSize={this.state.currentPageSize}
            onChange={this.onPaginationPageChange}
            onShowSizeChange={this.onPaginationPageSizeChange}
            showQuickJumper
          />
        </div>
      );
    } else {
      return null;
    }
  }

  /* user methods */

  onHeaderTabClick(tab) {
    this.setState({ currentTab: tab });
  }

  handleFiltersTimeChange = (dates) => {
    if (this.state.generatingBill) {
      this.showMessage(
        this.i18n.t("financeDownload.generatingWarning"),
        Base.Message.warning
      );
      return;
    }
    this.setState({ rangeTime: dates });
  };

  onGenerateClick = () => {
    if (this.state.generatingBill) {
      this.showMessage(
        this.i18n.t("financeDownload.generatingWarning"),
        Base.Message.warning
      );
      return;
    }

    this.showMessage(
      this.i18n.t("financeDownload.generating"),
      Base.Message.loading
    );
    this.generateBill();
  };

  onHistoryListItemDeleteClick = (item) => {
    if (!item) return;

    this.showMessage(
      this.i18n.t("financeDownload.deleting"),
      Base.Message.loading
    );
    this.deleteBill(item.id);
  };

  onPaginationPageChange = (page, pageSize) => {
    this.setState({ currentPage: page });
  };

  onPaginationPageSizeChange = (page, pageSize) => {
    this.setState({ currentPageSize: pageSize, currentPage: 1 });
  };

  /* server methods */

  async generateBill() {
    if (this.state.generatingBill) return;

    let token = this.getUserToken();
    if (!token) return;

    let api = this.api.order.export;
    let apiConfig = {
      token: token,
      query: {
        "filter[start_date]": this.state.rangeTime[0].format("YYYY-MM-DD"),
        "filter[end_date]": this.state.rangeTime[1].format("YYYY-MM-DD"),
      },
    };

    this.setState({ generatingBill: true });
    try {
      let res = await api.run(apiConfig);

      if (!this.mounted) return;

      if (res.result) {
        this.showMessage(
          this.i18n.t("financeDownload.generateSuccess"),
          Base.Message.success
        );
        this.setState({ currentTab: OrderDownload.Tabs[1], currentPage: 1 });
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ generatingBill: false });
    }
  }

  async loadList() {
    if (this.state.loadingList) return;

    let token = this.getUserToken();
    if (!token) return;

    let api = this.api.order.listExecl;
    let apiConfig = {
      token: token,
      query: {
        page: this.state.currentPage,
        count: this.state.currentPageSize,
        "filter[type]": 0,
      },
    };

    this.setState({ loadingList: true });
    try {
      let res = await api.run(apiConfig);

      if (!this.mounted) return;

      if (res.result) {
        let data = res.data;
        this.setState({ list: data });

        let list = data ? data.data : null;
        if (list && list.length > 0) {
          let generatingBill = list.find((item) => item.status === 0);
          if (generatingBill) {
            setTimeout(() => {
              if (!this.mounted) return;

              this.showMessage(
                this.i18n.t("financeDownload.updatingList"),
                Base.Message.loading
              );
              this.loadList();
            }, 3000);
          }
        } else {
          setTimeout(() => {
            if (this.afterSomeSecond >= 3) return;
            this.afterSomeSecond += 1;
            this.loadList();
          }, this.afterSomeSecond * 1000);
        }
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ loadingList: false });
    }
  }

  async deleteBill(id) {
    if (this.state.deletingBill) return;

    let token = this.getUserToken();
    if (!token) return;

    if (id <= 0) return;

    let api = this.api.checkout.deleteExel;
    let apiConfig = {
      token: token,
      path: {
        id: id,
      },
    };

    this.setState({ deletingBill: true });
    try {
      let res = await api.run(apiConfig);

      if (!this.mounted) return;

      if (res.result) {
        this.showMessage(
          this.i18n.t("financeDownload.deleteSuccess"),
          Base.Message.loading
        );
        this.loadList();
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ deletingBill: false });
    }
  }

  /* custom methods */

  disabledDate = (current) => {
    return current > this.moment().endOf("day");
  };

  getDefaultTimeRange() {
    let rangeTime = [this.moment().subtract(1, "days"), this.moment()];

    return rangeTime;
  }

  isCurrentTabGenerate() {
    return this.state.currentTab.key === OrderDownload.Tabs[0].key;
  }

  isCurrentTabHistory() {
    return this.state.currentTab.key === OrderDownload.Tabs[1].key;
  }
}

export default connect((state) => {
  return {
    user: getUserInfo(state),
  };
})(OrderDownload);
